import { Category } from "@/model/product";
import api from "./api";

class CategoryApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getCategory(): Promise<any> {
    const response = await this.getHttp().get("/categories", {
      data: {
        notLoading: true,
      }
    });
    const list: Category[] = [];
    const result = response.data.data;

    result.data.map((item: any) => list.push(new Category(item)));
    return result.data;
  }

  async all(query = {}): Promise<any> {
    const response = await this.getHttp().get("/categories", {
      data: {
        notLoading: true,
      },
      params: query
    });
    const list: Category[] = [];
    const result = response.data.data;
    result.map((item: any) => list.push(new Category(item)));
    return result;
  }
}

export default new CategoryApi();
